import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/img/idtype_app.png'
import _imports_1 from '@/assets/img/idtype_api.png'
import _imports_2 from '@/assets/img/idtype_evse.png'
import _imports_3 from '@/assets/img/idtype_offline_card.png'
import _imports_4 from '@/assets/img/idtype_card.png'
import _imports_5 from '@/assets/img/idtype_plan.png'


const _hoisted_1 = { class: "evse" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "icon-type",
  src: _imports_0,
  width: "48"
}
const _hoisted_6 = {
  key: 1,
  class: "icon-type",
  src: _imports_1,
  width: "48"
}
const _hoisted_7 = {
  key: 2,
  class: "icon-type",
  src: _imports_2,
  width: "48"
}
const _hoisted_8 = {
  key: 3,
  class: "icon-type",
  src: _imports_3,
  width: "48"
}
const _hoisted_9 = {
  key: 4,
  class: "icon-type",
  src: _imports_4,
  width: "48"
}
const _hoisted_10 = {
  key: 5,
  class: "icon-type",
  src: _imports_5,
  width: "48"
}
const _hoisted_11 = { class: "name-type-block" }
const _hoisted_12 = { class: "name-data" }
const _hoisted_13 = { class: "type-data" }
const _hoisted_14 = { class: "first-column-with-icon-type" }
const _hoisted_15 = { class: "name-type-block" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "first-column-with-icon-type"
}
const _hoisted_18 = { class: "name-type-block" }
const _hoisted_19 = { class: "name-data" }
const _hoisted_20 = { class: "type-data-mini" }
const _hoisted_21 = {
  key: 1,
  class: "first-column-with-icon-type"
}
const _hoisted_22 = {
  key: 0,
  class: "name-type-block"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "type-data-mini" }
const _hoisted_25 = {
  key: 1,
  class: "name-type-block"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "type-data" }, " - ", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "first-column-with-icon-type" }
const _hoisted_29 = { class: "name-type-block" }
const _hoisted_30 = { class: "type-data-block" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_33 = { class: "first-column-with-icon-type" }
const _hoisted_34 = { class: "name-type-block" }
const _hoisted_35 = { class: "type-data-block" }
const _hoisted_36 = { class: "type-data-block" }
const _hoisted_37 = { class: "first-column-with-icon-type" }
const _hoisted_38 = {
  key: 0,
  class: "name-type-block"
}
const _hoisted_39 = { class: "type-data-block" }
const _hoisted_40 = { class: "type-data-block" }
const _hoisted_41 = {
  key: 1,
  class: "name-type-block"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "type-data-block" }, " - ", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "first-column-with-icon-type" }
const _hoisted_45 = { class: "name-type-block" }
const _hoisted_46 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_47 = {
  key: 1,
  class: "type-data-block"
}
const _hoisted_48 = {
  key: 2,
  class: "type-data-block"
}
const _hoisted_49 = {
  key: 3,
  class: "type-data-block"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "emq-table-footer" }

import SelectEvse from '@/components/SelectEvse.vue'
import { getChargingOrderList } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { IdType, UserOrderStateFilter } from '@/types/types'
import { dateFormat, throttleBtn } from '@/common/tools'
import CommonPagination from '@/components/commonPagination.vue'
import EvseOrderStatus from '@/components/EvseOrderStatus.vue'
import EvseOrderPaymentStatus from '@/components/EvseOrderPaymentStatus.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Ref } from 'vue'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import SelectUser from '@/components/SelectUser.vue'
import { checkMenuShow } from '@/store/tool'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkUser from '@/components/Links/LinkUser.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'


import { defineComponent, ref, computed, defineProps } from 'vue'
import dayjs from 'dayjs'

const __default__ = defineComponent({
  name: 'Orders',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stationID: {
    type: String,
    default: '',
  },
  userID: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Evses')
const searchDateTime = ref<Array<Date>>([])

const showDialog = ref(false)
const showMoreQuery = ref(false)
const showOperator: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({
  state: UserOrderStateFilter.UOSF_ALL,
})
const { orderStates, getCurrencySymbol } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')



const isStation = computed(function () {
  return (
    (props.stationID != '' && props.stationID != '0') || (props.userID != '' && props.userID != '0')
  )
})

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  searchDateTime.value = []
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { orderId, stationId, operatorId, userId, state, evseId, recordId, paymentOrderId } = params
  newParams = {
    orderId: orderId || undefined,
    stationId: stationId || undefined,
    operatorId: operatorId || undefined,
    userId: userId || undefined,
    evseId: evseId || undefined,
    state: state || undefined,
    recordId: recordId || undefined,
    paymentOrderId: paymentOrderId || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    beginTime: '',
    endTime: '',
  }
  if (isStation.value) {
    sendParams.stationId = props.stationID
  }
  if (sendParams.stationId == '') {
    sendParams.stationId = '0'
  }
  if (!sendParams.userId || sendParams.userId == '' || sendParams.userId == '0') {
    sendParams.userId = props.userID
  }
  if (sendParams.userId == '') {
    sendParams.userId = '0'
  }

  if (searchDateTime.value.length) {
    sendParams.beginTime = dayjs(searchDateTime.value[0]).format('YYYY-MM-DD HH:mm:ss')
    sendParams.endTime = dayjs(searchDateTime.value[1]).format('YYYY-MM-DD HH:mm:ss')
  }
  try {
    const { list = [], pageReply = {} } = await getChargingOrderList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTableData)
loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isStation))
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectUser, {
                      modelValue: fuzzyParams.value.userId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.userId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectStation, {
                      modelValue: fuzzyParams.value.stationId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.stationId) = $event)),
                      operatorID: fuzzyParams.value.operatorId
                    }, null, 8, ["modelValue", "operatorID"])
                  ]),
                  _: 1
                }, 16),
                (showMoreQuery.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(SelectEvse, {
                            modelValue: fuzzyParams.value.evseId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.evseId) = $event)),
                            "operator-i-d": fuzzyParams.value.operatorId
                          }, null, 8, ["modelValue", "operator-i-d"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: searchDateTime.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchDateTime).value = $event)),
                            type: "datetimerange",
                            "range-separator": "-",
                            "start-placeholder": _ctx.$t('Base.beginTime'),
                            "end-placeholder": _ctx.$t('Base.endTime')
                          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.orderId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fuzzyParams.value.orderId) = $event)),
                            placeholder: _ctx.$t('Base.id'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.recordId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fuzzyParams.value.recordId) = $event)),
                            placeholder: _ctx.$t('Base.recordId'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.paymentOrderId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fuzzyParams.value.paymentOrderId) = $event)),
                            placeholder: _ctx.$t('Base.paymentOrderId'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_tooltip, {
                      content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "icon-button",
                          plain: "",
                          icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_radio_group, {
          class: "legend-select",
          modelValue: fuzzyParams.value.state,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fuzzyParams.value.state) = $event)),
          onChange: handleSearch,
          disabled: lockTable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_ALL
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.all')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_PROCESS
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.orderProcess')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_UNPAID
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.payStatePayPending')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_FINISH
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.orderFinish')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_PREPARE
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.orderManualPending')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_ABNORMAL
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.abnormal')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(UserOrderStateFilter).UOSF_OCCUPY
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.occupying')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "ID"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "ID",
            width: "250",
            label: _ctx.$t('Order.orderID'),
            fixed: "",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_router_link, {
                to: { name: 'order-detail', params: { id: row.ID } },
                class: _normalizeClass(["first-column-with-icon-type", { 'disabled-link': !_unref(checkMenuShow)('sessionInfo') }])
              }, {
                default: _withCtx(() => [
                  (
                row.authorizationMode == _unref(IdType).IT_REMOTE_USER ||
                row.authorizationMode == _unref(IdType).IT_REMOTE_ADMIN
              )
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (row.authorizationMode == _unref(IdType).IT_REMOTE_API)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : (
                row.authorizationMode == _unref(IdType).IT_LOCAL_PLUG ||
                row.authorizationMode == _unref(IdType).IT_ONLINE_VIN
              )
                        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                        : (
                row.authorizationMode == _unref(IdType).IT_LOCAL_IDENTITY_CARD ||
                row.authorizationMode == _unref(IdType).IT_LOCAL_WALLET_CARD
              )
                          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                          : (row.authorizationMode == _unref(IdType).IT_ONLINE_IDENTITY_CARD)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(row.ID), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "stationName",
            width: "150",
            label: _ctx.$t('Order.location')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(LinkStation, {
                    id: row.stationId,
                    name: row.stationName
                  }, null, 8, ["id", "name"]),
                  _hoisted_16,
                  _createVNode(LinkOperator, {
                    id: row.evseOperatorId,
                    name: row.evseOperatorName
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            width: "120",
            label: _ctx.$t('Order.user')
          }, {
            default: _withCtx(({ row }) => [
              (row?.groupId != '0' && row?.groupId != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(row.groupName), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(row.authorizationID), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (row.userName != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(LinkUser, {
                            id: row.userID,
                            name: row.userName
                          }, null, 8, ["id", "name"]),
                          _hoisted_23,
                          _createElementVNode("span", _hoisted_24, _toDisplayString(row.authorizationID), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                  ]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "evse",
            width: "150",
            label: _ctx.$t('Order.evse')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createElementVNode("span", null, [
                      _createVNode(LinkEvse, {
                        id: row.evseID,
                        name: row.connectorDesc
                      }, null, 8, ["id", "name"])
                    ]),
                    (row.reserverOrderAt > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                          _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('Order.reserverDesc'),
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, {
                                type: "primary",
                                effect: "plain",
                                size: "small",
                                hit: false,
                                round: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Order.reserverTag')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (row.reserverOrderAt > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                        _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.reserverOrderAt) * 1000)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            width: 140,
            "show-overflow-tooltip": true,
            label: _ctx.$t('Evses.state')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, [
                    _createVNode(EvseOrderStatus, {
                      state: row.state
                    }, null, 8, ["state"])
                  ]),
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(EvseOrderPaymentStatus, {
                      state: row.paymentState,
                      settleState: row.settlementState
                    }, null, 8, ["state", "settleState"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "stopReason",
            "min-width": 150,
            "show-overflow-tooltip": true,
            label: _ctx.$t('Order.stopReason')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_37, [
                (row.stopReason != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)(`Order.stopReasonCode`)) + ": " + _toDisplayString(row.stopReason), 1),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(row.stopReasonDesc), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargeStartTime",
            width: "180",
            label: _ctx.$t('Order.chargingRangeTime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  (row.chargeStartTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(dateFormat)(Number(row.chargeStartTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_47, "-")),
                  (row.chargeStopTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_unref(dateFormat)(Number(row.chargeStopTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_49, "-"))
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "cost.totalElectric",
            width: "120",
            label: _ctx.$t('Order.orderElec'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(row.cost.totalElectric) + " KWh", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "cost.totalAmount",
            width: "120",
            label: _ctx.$t('Order.orderAmount'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(row.cost.totalAmount), 1),
              (row.currency > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(getCurrencySymbol)(row.currency)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            className: "table-operation",
            width: "80"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: { name: 'order-detail', params: { id: row.ID } },
                    class: _normalizeClass({ 'disabled-link': !_unref(checkMenuShow)('sessionInfo') })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.view')), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[10] || (_cache[10] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ])
    ])
  ]))
}
}

})